import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { ServerService } from "../server.service";
@Component({
  selector: 'app-modulo-estudiante',
  templateUrl: './modulo-estudiante.component.html',
  styleUrls: ['./modulo-estudiante.component.css']
})
export class ModuloEstudianteComponent implements OnInit {
  listaencuesta:any[]
  constructor(private router:Router,private server: ServerService) { }

  ngOnInit(): void {
    this.server.getEncuestasestudiantes().subscribe((res:any)=>{
      this.listaencuesta= res;
    })
  }
logout():void{
  localStorage.removeItem("rol")
  this.router.navigateByUrl('/login');
}

}
